import React from 'react';
import { useSelector } from 'react-redux';
import * as appUtilityFunction from '../../../../infrastructure/apputilityfunctions'

export default function List({ dashboardId }) {
    const dashboardData = useSelector(
        state => state.dashboardReducer.userDashboard.userdashboardData
    );

    if (dashboardData === null) {
        return <div />;
    }

    const datas = dashboardData[dashboardId];
    const dataRows = datas.dataRows;

    if (dataRows.length === 0) {
        return <div />;
    }

    const getFieldNames = () => {
        const fieldNames = dataRows.reduce((uniqueNames, item) => {
            item.fields.forEach(field => {
                if (!uniqueNames.includes(field.fieldName)) {
                    uniqueNames.push(field.fieldName);
                }
            });
            return uniqueNames;
        }, []);
        return fieldNames;
    };

    /* const getFieldValue = (item, fieldName) => {
         const field = item.fields.find(field => field.fieldName === fieldName);
         return field ? field.fieldValue : '';
       };
       */
    const getFieldValue = (item, fieldName) => {
        const field = item.fields.find(field => field.fieldName === fieldName);
        if (field && appUtilityFunction.isDate(field.fieldValue)) {
            return appUtilityFunction.formatDate(field.fieldValue);
        }
        return field ? field.fieldValue : '';
    }
    return (
        <div class="col-xl-6 col-lg-12" key={dashboardId}>
            <div class="card">
                <div class="card-body">
                <div className="alert alert-primary" role="alert">
                        <h4> <i className='mdi mdi-card-account-details'></i> {datas.dashboardTitle} </h4>
                    </div>
                    <div class="table-responsive">
                    <table class="table table-bordered table-centered mb-0 table-striped">
                            <thead class="table-primary">
                                <tr >
                                    {getFieldNames().map(fieldName => (
                                        <th style={{ "width": "30%" }} key={fieldName}>{fieldName}</th>
                                    ))}
                                </tr>
                            </thead>
                            <tbody>
                                {dataRows.length > 0 &&
                                    dataRows.map((item, index) => (
                                        <tr key={index}>
                                            {getFieldNames().map(fieldName => (
                                                <td key={`${fieldName}-${index}`}>
                                                    {fieldName === 'STAGE' ? (
                                                        <span className={appUtilityFunction.getStatusBadge(getFieldValue(item, fieldName))}>
                                                            {String(getFieldValue(item, fieldName))}
                                                        </span>
                                                    ) : (
                                                        String(getFieldValue(item, fieldName))
                                                    )}
                                                </td>
                                            ))}
                                        </tr>
                                    ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    );
}
